import axios from "axios";

export const getAPIUrl = () => {
    if (process.env.REACT_APP_API_URL) {
        return `${process.env.REACT_APP_API_URL}`;
    }
    return `${window.location.protocol}//${window.location.hostname}/api/v1_0`;
};

export const getLookupList = async (sectionName) => {
    try {
        const res = await axios.get(`${getAPIUrl()}/${sectionName}`);
        return res.data;
    } catch (error) {
        console.error(`Ошибка при получении данных для раздела ${sectionName}:`, error);
        throw error; // Передаем ошибку дальше для обработки в компоненте
    }
};